
export const queueStatuses = {
    cancelled: "cancelled",
    error: "error",
    pending: "pending",
    success: "success",
};
